export const operationStatus = {
  initial: 'Inicial',
  pending: 'Pendiente',
  success: 'Éxito',
  failed: 'Rechazado',
  cancelled: 'Cancelado',
  signed: 'Firmado',
  viewed: 'Visto'
};

export const OPERATION_STATUS = {
  initial:1,
  pending: 2,
  success: 3,
  failed: 4,
  cancelled: 5,
  signed: 6,
  viewed:7
};
